import api from "@/services/api";

export const state = {
  extracts: [],
  extract: {},
  nextOrdinalNumber: null,
};

export const mutations = {
  INIT_EXTRACTS(state, payload) {
    state.extracts = payload;
  },
  INIT_EXTRACT(state, payload) {
    state.extract = payload;
  },
  INIT_NEXT_ORDINAL_NUMBER(state, payload) {
    state.nextOrdinalNumber = payload;
  },
};

export const actions = {
  getExtracts({ commit }, payload) {
    return api.getAssociationExtracts(payload).then((response) => {
      commit("INIT_EXTRACTS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getExtractById({ commit }, payload) {
    return api.getAssociationExtractById(payload).then((response) => {
      commit("INIT_EXTRACT", response.data.data);
    });
  },
  getNextOrdinalNumber({ commit }, payload) {
    return api.getNextOrdinalNumber(payload).then((response) => {
      commit("INIT_NEXT_ORDINAL_NUMBER", response.data.data);
    });
  },
};

export const getters = {
  getExtracts: (state) => state.extracts,
  getExtract: (state) => state.extract,
  getNextOrdinalNumber: (state) => state.nextOrdinalNumber,
};
